var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('status-page',{attrs:{"statusPageType":2}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--1!./node_modules/vue-loader/lib??vue-loader-options!./src/views/DataUpdates.vue?vue&type=template&id=04590728&
// module id = null
// module chunks = 